import { render, staticRenderFns } from "./Pneumo.vue?vue&type=template&id=d3cf30b8"
import script from "./Pneumo.vue?vue&type=script&lang=js"
export * from "./Pneumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports